import { Box, Divider, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import BasicTable from './BasicTable';

const DescriptionBox = ({
  title, description, refProp, showBasicTable = false, columns, rows,
}) => {
  return (
    <Box
      ref={refProp}
      sx={{
        background: "#ffffff",
      }}
    >
      <Typography
        pl={{ xs: 2, md: 4 }}
        color="#000000"
        sx={{ fontSize: { xs: "20px", md: "24px" }, fontWeight: "700" }}
      >
        {title}
      </Typography>
      <Divider variant="middle" sx={{ marginLeft: { xs: "16px", md: "32px" } }} />
      <Box
        sx={{
          backgroundColor: "#ffffff",
          padding: { xs: "12px 16px", md: "16px 32px" },
        }}
      >
        <Typography sx={{ fontSize: "18px", fontWeight: "400", color: "#000" }}>
          {description}
        </Typography>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        margin="10px 0"
      >
        <Box width="95%">
          {showBasicTable && columns && rows ? (
            <BasicTable columns={columns} rows={rows} />
          ) : null}
        </Box>
      </Box>
    </Box>
  );
};

DescriptionBox.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  refProp: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
  showBasicTable: PropTypes.bool,
  columns: PropTypes.array,
  rows: PropTypes.array,
};

export default DescriptionBox;
